import { render, staticRenderFns } from "./Takings.vue?vue&type=template&id=30043fdf&scoped=true"
import script from "./Takings.vue?vue&type=script&lang=js"
export * from "./Takings.vue?vue&type=script&lang=js"
import style0 from "./Takings.vue?vue&type=style&index=0&id=30043fdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30043fdf",
  null
  
)

export default component.exports